<template>
  <AuthLayoutFull center>
    <PackagePlanBoxes slot="content" />
  </AuthLayoutFull>
</template>

<script>
import AuthLayoutFull from '@/components/auth/AuthLayoutFull'
import PackagePlanBoxes from '@/components/PackagePlanBoxes'

export default {
  components: {
    PackagePlanBoxes,
    AuthLayoutFull
  }

}
</script>
